const FORM_TEMPLATE_TYPE = {
    regular: 'regular',
    offer: 'offer',
    transition: 'transition',
    application: 'application',
    acceptance: 'acceptance',
    shareable: 'shareable'
};

export default FORM_TEMPLATE_TYPE;